"use client";

import React, { useMemo } from "react";
import PropTypes from "prop-types";
import Modal from "../../../../components/Modal";
import Table from "../../../../components/Table";
import Button from "../../../../components/Button";
import styles from "../css/CustomerFamilyModal.module.css";

export default function CustomerFamilyModal({ open, onClose, customer, rows, onSelect, title = "Customer Details", actionLabel = "Select" }) {
  const data = useMemo(() => {
    if (rows && rows.length) return rows;
    if (!customer) return [];
    const baseSurname = customer.surname || "";
    const main = {
      surname: baseSurname,
      initial: customer.initial || "",
      title: customer.title || "",
      role: "Main Member",
      raw: customer,
    };
    // Mock dependants for now; can be replaced with API data later
    const dependants = [
      { surname: baseSurname, initial: "L", title: "Mr", role: "Dependent" },
      { surname: baseSurname, initial: "M", title: "Ms", role: "Dependent" },
    ];
    return [main, ...dependants];
  }, [rows, customer]);

  const columns = useMemo(
    () => [
      { header: "Surname", accessor: "surname" },
      { header: "Initial", accessor: "initial" },
      { header: "Title", accessor: "title" },
      { header: "Role", accessor: "role" },
      {
        header: "Action",
        accessor: "action",
        render: (_v, row) => (
          <Button
            variant="primary"
            onClick={() => {
              if (onSelect) onSelect(row);
              onClose?.();
            }}
          >
            {actionLabel}
          </Button>
        ),
      },
    ],
    [onClose, onSelect, actionLabel]
  );

  if (!open) return null;

  return (
    <Modal onClose={onClose}>
      <div className={styles.title}>{title}</div>
      <Table columns={columns} data={data} />
    </Modal>
  );
}

CustomerFamilyModal.propTypes = {
  open: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  customer: PropTypes.object,
  rows: PropTypes.array,
  onSelect: PropTypes.func,
  title: PropTypes.string,
  actionLabel: PropTypes.string,
};
